/**
 * Mobile topbar — hamburger · centered title with app accent dot ·
 * search (placeholder) · more (jumps to settings).
 */

import { useT } from "../lib/i18n";
import { Icon } from "../lib/icons";

interface MobileTopbarProps {
  title: string;
  appTint: string;
  onMenu(): void;
  onSettings(): void;
}

export function MobileTopbar({
  title,
  appTint,
  onMenu,
  onSettings,
}: MobileTopbarProps): JSX.Element {
  const [, T] = useT();
  return (
    <div className="vz-topbar" style={{ padding: "12px 14px" }}>
      <button
        type="button"
        className="vz-btn vz-btn-ghost vz-btn-icon"
        onClick={onMenu}
        aria-label={T("shell.openMenu")}
      >
        <Icon.menu />
      </button>
      <div className="vz-topbar-title">
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: 3,
            background: `var(${appTint})`,
          }}
        />
        {title}
      </div>
      <span style={{ flex: 1 }} />
      <button
        type="button"
        className="vz-btn vz-btn-ghost vz-btn-icon"
        title={T("comingSoon")}
        disabled
      >
        <Icon.search />
      </button>
      <button
        type="button"
        className="vz-btn vz-btn-ghost vz-btn-icon"
        onClick={onSettings}
        aria-label={T("settings")}
      >
        <Icon.more />
      </button>
    </div>
  );
}
